import { registerDestructor } from '@ember/destroyable';
import Service, { type Registry as Services, service } from '@ember/service';
import { THEME } from 'frontend-utils/utils/prism/theme';

export default class ThemeService extends Service {
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];

  dataThemeElement: HTMLHtmlElement | Element | null = document.documentElement;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get currentTheme() {
    if (!this.hasPermissions) {
      return THEME.LIGHT;
    }

    return this.selectedTheme;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get hasPermissions() {
    return this.hotelAndMarketService.user?.themeAccess;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get selectedTheme() {
    const selectedTheme = this.hotelAndMarketService.user?.theme ?? THEME.LIGHT;

    if (selectedTheme === THEME.SYSTEM) {
      return window.matchMedia('(prefers-color-scheme: dark)').matches
        ? THEME.DARK
        : THEME.LIGHT;
    }

    if (selectedTheme === THEME.HIGH_CONTRAST_SYSTEM) {
      return window.matchMedia('(prefers-color-scheme: dark)').matches
        ? THEME.HIGH_CONTRAST_DARK
        : THEME.HIGH_CONTRAST_LIGHT;
    }

    return selectedTheme;
  }

  setTheme(): void {
    this.dataThemeElement?.setAttribute('data-theme', this.currentTheme);
  }

  start(): void {
    const preference = window.matchMedia('(prefers-color-scheme: dark)');

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    const setPreference = () => {
      this.setTheme();
    };
    preference.addEventListener('change', setPreference);
    registerDestructor(this, () =>
      preference.removeEventListener('change', setPreference),
    );
    this.setTheme();
  }
}

declare module '@ember/service' {
  interface Registry {
    theme: ThemeService;
  }
}
